import React, { useState } from "react";
import Contact from "../Images/contact.png";
import { Card, Form, Button, Row, Col, Container } from "react-bootstrap";
import Footer from "./Footer";
import Nav from "./Navbar";
const Connectus = () => {
  return (
    <>
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        <div>
          <Nav />
        </div>
        <Row className="d-flex justify-content-center">
          <Col md={10}>
            <Row style={{ height: "" }} className="mx-1 mb-2 mt-5 mb-5">
            <Col md={7} className="d-flex">
                <div style={{ width: "100%", height: "75vh" }}>
                  <iframe
                    title="SeoBix Location"
                    src="https://www.google.com/maps?q=B-212A%20ithum%20tower%20sector%2062%20noida&output=embed"
                    width="100%"
                    height="100%"
                    style={{ border: 0, borderRadius: "1rem" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </Col>
              <Col
                md={5}
                className="d-flex flex-column justify-content-end align-items-start"
              >
                <Card className="p-3 shadow-sm" style={{ border: "none" }}>
                  <Card.Body>
                    <Card.Title className="mb-4">
                      Start Your Free Trial with{" "}
                      <span style={{ color: "#5089EB" }}>SeoBix</span> Today!
                    </Card.Title>
                    <Form>
                      <Form.Group controlId="formName" className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="FULL NAME"
                          className="custom-placeholder"
                        />
                      </Form.Group>
                      <Form.Group controlId="formMobile" className="mb-3">
                        <Form.Control
                          type="tel"
                          placeholder="MOBILE"
                          className="custom-placeholder"
                        />
                      </Form.Group>
                      <Form.Group controlId="formEmail" className="mb-3">
                        <Form.Control
                          type="email"
                          placeholder="EMAIL"
                          className="custom-placeholder"
                        />
                      </Form.Group>
                      <Form.Group controlId="formWebsite" className="mb-3">
                        <Form.Control
                          type="url"
                          placeholder="WEBSITE"
                          className="custom-placeholder"
                        />
                      </Form.Group>
                      <Form.Group controlId="formCompanyName" className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="COMPANY NAME"
                          className="custom-placeholder"
                        />
                      </Form.Group>
                      <Form.Group controlId="formPassword" className="mb-3">
                        <Form.Control
                          type="password"
                          placeholder="CREATE PASSWORD"
                          className="custom-placeholder"
                        />
                      </Form.Group>
                      <Row>
                        <Form.Group controlId="formDA" className=" col mb-3">
                          <Form.Control
                            type="number"
                            placeholder="DOMAIN AUTHORITY"
                            className="custom-placeholder"
                          />
                        </Form.Group>
                        <Form.Group controlId="formPA" className=" col mb-3">
                          <Form.Control
                            type="number"
                            placeholder="PAGE AUTHORITY"
                            className="custom-placeholder"
                          />
                        </Form.Group>
                      </Row>

                      <Button
                        style={{
                          background: "#5089EB",
                          borderRadius: "1.2rem",
                        }}
                        type="submit"
                        className="w-100"
                      >
                        Start Free Trial
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background: "#31393C",
            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        >
          <Footer />
        </div>{" "}
      </Container>
    </>
  );
};

export default Connectus;
